/**
 * EchoConnection.js
 * -----------------
 * Single source of truth for the Laravel Echo / Pusher connection.
 * Responsible ONLY for: creating, exposing, and monitoring the socket.
 *
 * Nothing else belongs here.
 */

import Echo from "laravel-echo";
import Pusher from "pusher-js/worker";

// ─── Bootstrap Pusher (required by Echo's pusher broadcaster) ────────────────
window.Pusher = Pusher;

// ─── Create the singleton Echo instance ──────────────────────────────────────
const echo = new Echo({
    broadcaster:  "pusher",
    key:          import.meta.env.VITE_ABLY_KEY,
    wsHost:       "realtime-pusher.ably.io",
    wsPort:       443,
    encrypted:    true,
    disableStats: true,
    namespace:    "App.Events",
    pongTimeout:  10_000,
});

export default echo;
